import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateAssessmentForm from "../../forms/CreateOrUpdateAssessmentForm";

interface CreateAssessmentModalProps {
  open: boolean;
  onClose: () => void;
  loading: boolean;
  error: string | null;
}

const CreateAssessmentModal: React.FC<CreateAssessmentModalProps> = ({
  open,
  onClose,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title="New Assessment Configuration"
    width="md"
    loading={loading}
  >
    <CreateOrUpdateAssessmentForm loading={loading} error={error} />
  </AppModal>
);

export default CreateAssessmentModal;
